import { IconDoc } from '@/components/Icons/IconDoc';
import { IconDownload } from '@/components/Icons/IconDownload';
import { IconPlay } from '@/components/Icons/IconPlay';

type ResourceListItemProps = {
  href: string;
  title: string;
  description?: string | null;
  subTitle?: string | null;
  type?: 'download' | 'video';
};

const stripHtml = (html: string) => html.replace(/<[^>]*>/g, '').trim();

export const ResourceListItem = ({ href, title, description, subTitle, type = 'download' }: ResourceListItemProps) => {
  const isDownload = type === 'download';
  const plainDescription = description ? stripHtml(description) : null;

  return (
    <a
      aria-label={isDownload ? `Download ${title}` : `Open ${title}`}
      className="flex items-start gap-3 shadow rounded-lg p-4 no-underline color-black hover:shadow-lg transition-150"
      href={href}
      rel="noopener noreferrer"
      target="_blank"
    >
      <div className="shrink-0 mt-1">{isDownload ? <IconDoc /> : <IconPlay />}</div>
      <div className="flex-1 min-w-0">
        <p className="font-bold text-sm mb-0 leading-tight">{title}</p>
        {plainDescription && (
          <p className="color-grey-600 text-sm mb-0 mt-1">{plainDescription}</p>
        )}
        {isDownload && subTitle && (
          <p className="color-grey-500 text-xs mb-0 mt-1" style={{ fontFamily: 'monospace' }}>
            {subTitle}
          </p>
        )}
      </div>
      {isDownload ? (
        <IconDownload className="shrink-0 color-primary mt-1" />
      ) : (
        subTitle && (
          <span className="shrink-0 color-grey-500 text-xs mt-1" style={{ fontFamily: 'monospace', fontVariantNumeric: 'tabular-nums' }}>
            {subTitle}
          </span>
        )
      )}
    </a>
  );
};
